import { cn } from '@/lib/utils';

export default function HomeSkeleton() {
  return (
    <div className="min-h-screen bg-background">
      {/* Navbar skeleton */}
      <div className="h-16 border-b border-border/50 bg-surface-0/80 backdrop-blur-md">
        <div className="mx-auto max-w-7xl px-4 h-full flex items-center justify-between">
          <div className="h-8 w-32 bg-surface-2 rounded-lg animate-pulse" />
          <div className="flex gap-4">
            <div className="h-8 w-20 bg-surface-2 rounded-lg animate-pulse" />
            <div className="h-8 w-20 bg-surface-2 rounded-lg animate-pulse" />
            <div className="h-8 w-20 bg-surface-2 rounded-lg animate-pulse" />
          </div>
        </div>
      </div>
      
      {/* Hero skeleton */}
      <div className="mx-auto max-w-7xl px-4 py-20">
        <div className="text-center space-y-6">
          <div className="h-12 w-3/4 mx-auto bg-surface-2 rounded-lg animate-pulse" />
          <div className="h-6 w-1/2 mx-auto bg-surface-2 rounded-lg animate-pulse" />
          <div className="flex justify-center gap-4 mt-8">
            <div className="h-12 w-36 bg-brand-glow/20 rounded-lg animate-pulse" />
            <div className="h-12 w-36 bg-surface-2 rounded-lg animate-pulse" />
          </div>
        </div>
      </div>
      
      {/* Features skeleton */}
      <div className="mx-auto max-w-7xl px-4 py-16 grid grid-cols-1 md:grid-cols-3 gap-8">
        {[1, 2, 3].map((i) => (
          <div key={i} className="p-6 rounded-2xl bg-surface-1 border border-border/50">
            <div className="h-10 w-10 rounded-lg bg-surface-2 animate-pulse mb-4" />
            <div className="h-6 w-3/4 bg-surface-2 rounded-lg animate-pulse mb-2" />
            <div className="h-4 w-full bg-surface-2 rounded-lg animate-pulse" />
            <div className="h-4 w-5/6 bg-surface-2 rounded-lg animate-pulse mt-2" />
          </div>
        ))}
      </div>
    </div>
  );
}
